import { LinearProgress } from '@mui/material';
import { AnimatedLogo } from './AnimatedLogo';

const LoadingBar = () => {
    return (
        <div className="loading-bar">
            <AnimatedLogo width={64} height={64} style={{ margin: '0 auto' }} />
            <div style={{ width: '64px' }}>
                <LinearProgress sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: '#fff'
                    },
                    borderRadius: '9999px',
                    height: 6
                }} />
            </div>
        </div>
    );
}

export default LoadingBar;